import { render, staticRenderFns } from "./CloseButtonPreviewIcon.vue?vue&type=template&id=779b892f&scoped=true&"
import script from "./CloseButtonPreviewIcon.vue?vue&type=script&lang=ts&"
export * from "./CloseButtonPreviewIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CloseButtonPreviewIcon.vue?vue&type=style&index=0&id=779b892f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779b892f",
  null
  
)

export default component.exports